// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as RegisterPurchaseActions } from '../duck';
import RegisterPurchase from '../components/RegisterPurchase';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    itemLoadingMap: state.order.purchase.registerPurchase.itemLoadingMap,
    itemErrorMap: state.order.purchase.registerPurchase.itemErrorMap,
    order: state.order.order,
    motives: state.report.motives,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(RegisterPurchaseActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterPurchase);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/register-purchase/containers/RegisterPurchaseContainer.js